import { Link } from 'react-router-dom';
import './Homepage.css';

function Homepage({ isAuthenticated }) {
    return (
        <div className="homepage">
            {/* Hero Section */}
            <section className="hero-section">
                <div className="container">
                    <div className="hero-content">
                        <div className="hero-left">
                            <h1 className="hero-title">
                                Collaborative AI<br />
                                Computing <span className="text-blue">Time-Shared</span>
                            </h1>
                            <p className="hero-subtitle">
                                Access high-performance GPU resources through our intelligent scheduling platform. Build, train, and deploy AI models in containerized Jupyter environments with real-time collaboration.
                            </p>
                            <div className="hero-buttons">
                                <Link to={isAuthenticated ? "/dashboard" : "/login"} className="btn-hero-primary">
                                    Go to Dashboard →
                                </Link>
                                <button className="btn-hero-secondary">Book GPU Time</button>
                            </div>
                        </div>
                        <div className="hero-image">
                            <div className="hero-gradient-box">
                                <img src="/hero-collaboration.png" alt="Team Collaboration" />
                            </div>
                        </div>
                    </div>

                    {/* Stats */}
                    <div className="stats-row">
                        <div className="stat-box">
                            <div className="stat-value-large">99.9%</div>
                            <div className="stat-label-small">UPTIME</div>
                        </div>
                        <div className="stat-box">
                            <div className="stat-value-large">4x<br />A100</div>
                            <div className="stat-label-small">GPU<br />POWER</div>
                        </div>
                        <div className="stat-box">
                            <div className="stat-value-large">24/7</div>
                            <div className="stat-label-small">AVAILABLE</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Features */}
            <section className="features-section">
                <div className="container">
                    <div className="features-grid-4">
                        <div className="feature-box">
                            <div className="feature-image">
                                <img src="/docs-style-landing-card.png" alt="Smart Scheduling" />
                            </div>
                            <h3>Smart Scheduling</h3>
                            <p>Book GPU time slots with intelligent conflict detection and automated resource allocation</p>
                        </div>
                        <div className="feature-box">
                            <div className="feature-image">
                                <img src="/card2.png" alt="Real-time Collaboration" />
                            </div>
                            <h3>Real-time Collaboration</h3>
                            <p>Work together on notebooks with live code execution and shared sessions</p>
                        </div>
                        <div className="feature-box">
                            <div className="feature-image">
                                <img src="/card3.png" alt="Secure & Isolated" />
                            </div>
                            <h3>Secure & Isolated</h3>
                            <p>Each session runs in its own Docker container with complete resource isolation</p>
                        </div>
                        <div className="feature-box">
                            <div className="feature-image">
                                <img src="/card-hero.png" alt="Pre-configured Environments" />
                            </div>
                            <h3>Pre-configured Environments</h3>
                            <p>Start coding immediately with PyTorch, TensorFlow, and JAX already installed</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Collaboration */}
            <section className="collab-section">
                <div className="container">
                    <div className="collab-flex">
                        <div className="collab-text">
                            <h2>Collaborate in Real-Time</h2>
                            <p>Work together with your team in the same Jupyter notebook. See live code execution, share outputs, and debug collaboratively with WebSocket-powered real-time updates.</p>
                            <button className="btn-hero-primary">Get Started →</button>
                        </div>
                        <div className="collab-graphic">
                            <div className="collab-placeholder">
                                <img src="/colaborating-generic.png" alt="Real-time Collaboration" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA */}
            <section className="cta-section">
                <div className="container">
                    <h2>Ready to accelerate your AI development?</h2>
                    <p>Join the NeuAIs platform and get instant access to high-performance computing resources</p>
                    {!isAuthenticated && (
                        <Link to="/login" className="btn-hero-primary">Get Started Now →</Link>
                    )}
                </div>
            </section>
        </div>
    );
}

export default Homepage;
